import { MouseEventHandler, ReactChild } from "react";

import Spinner from "components/Spinner";

import "./WarningDialog.css";

const WarningDialog = ({
  children,
  onClose,
  title,
  dialogStatus,
}: {
  children: ReactChild;
  onClose: MouseEventHandler<HTMLDivElement>;
  title: string;
  dialogStatus?: "loading" | "success";
}) => {
  return (
    <>
      <div className="WarningDialog__screenCancel" onClick={onClose} />
      <div className="WarningDialog">
        <h1 className="WarningDialog__header">{title}</h1>
        <div className="WarningDialog__container">
          {dialogStatus === "loading" && (
            <div className="WarningDialog__spinner">
              <Spinner />
            </div>
          )}
          {children}
        </div>
      </div>
    </>
  );
};

export default WarningDialog;
